module.exports = __webpack_public_path__ + "static/img/02-03.c47e4cb1.png";